import React, { useContext } from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import {
  FaHome, FaBookOpen, FaEdit, FaFileAlt, FaTasks, FaComments,
  FaTrashAlt, FaUserCog, FaUsers, FaMapMarkedAlt,
} from 'react-icons/fa';
import { AuthContext } from '../contexts/AuthContext';
import { LanguageContext } from '../contexts/LanguageProvider';
import '../styles/NavBar.css';

const translations = {
  pt: {
    home: 'Início',
    reader: 'Leitor',
    editor: 'Editor',
    admin: 'Admin',
    viewBooks: 'Visualizar Livros',
    editBooks: 'Editar Livros',
    editChapters: 'Editar Capítulos',
    manageTasks: 'Gerenciar Tarefas',
    manageComment: 'Gerenciar Comentários',
    editProfile: 'Editar Perfil',
    manageUsers: 'Gerenciar Usuários',
    myComments: 'Meus Comentários',
    CommentDeleted: 'Comentários Deletados',
    config: 'Configurações',
    geo: 'Geo',
    products: 'Produtos',
  },
  en: {
    home: 'Home',
    reader: 'Reader',
    editor: 'Editor',
    admin: 'Admin',
    viewBooks: 'View Books',
    editBooks: 'Edit Books',
    editChapters: 'Edit Chapters',
    manageTasks: 'Manage Tasks',
    manageComment: 'Manage Comments',
    editProfile: 'Edit Profile',
    manageUsers: 'Manage Users',
    myComments: 'My Comments',
    CommentDeleted: 'Deleted Comments',
    config: 'Settings',
    geo: 'Geo',
    products: 'Products',
  },
};

const NavBar = ({ isMobile = false, onLinkClick }) => {
  const { isLoggedIn, role } = useContext(AuthContext);
  const { language } = useContext(LanguageContext);

  const t = translations[language] || translations.pt;

  const handleLinkClick = () => {
    if (isMobile && onLinkClick) onLinkClick();
  };

  const linksByRole = {
    ADMIN: [
      ['/admin/roles', t.manageUsers, <FaUsers />],
      ['/admin/read', t.viewBooks, <FaBookOpen />],
      ['/admin/edit-books', t.editBooks, <FaEdit />],
      ['/admin/edit-chapters', t.editChapters, <FaFileAlt />],
      ['/admin/tasks', t.manageTasks, <FaTasks />],
      ['/admin/comment', t.manageComment, <FaComments />],
      ['/admin/comment-deleted', t.CommentDeleted, <FaTrashAlt />],
      ['/admin/profile', t.editProfile, <FaUserCog />],
      ['/admin/geo', t.geo, <FaMapMarkedAlt />],
    ],
    EDITOR: [
      ['/editor/read', t.viewBooks, <FaBookOpen />],
      ['/editor/edit-books', t.editBooks, <FaEdit />],
      ['/editor/edit-chapters', t.editChapters, <FaFileAlt />],
      ['/editor/tasks', t.manageTasks, <FaTasks />],
      ['/editor/comment', t.manageComment, <FaComments />],
      ['/editor/profile', t.editProfile, <FaUserCog />],
    ],
    READER: [
      ['/reader/read', t.viewBooks, <FaBookOpen />],
      ['/reader/comment', t.myComments, <FaComments />],
      ['/reader/profile', t.editProfile, <FaUserCog />],
    ],
  };

  const roleLinks = (isLoggedIn && linksByRole[role]) || [];
  const roleTitle =
    role === 'ADMIN' ? t.admin :
    role === 'EDITOR' ? t.editor :
    role === 'READER' ? t.reader : '';

  if (isMobile) {
    return (
      <Nav className="flex-column mobile-navbar">
        <Nav.Link as={NavLink} to="/" end onClick={handleLinkClick}>
          <FaHome className="nav-icon" /> {t.home}
        </Nav.Link>
        {roleLinks.length > 0 && (
          <>
            <div className="nav-section-title">{roleTitle}</div>
            {roleLinks.map(([to, label, icon]) => (
              <Nav.Link as={NavLink} to={to} key={to} onClick={handleLinkClick}>
                <span className="nav-icon">{icon}</span> {label}
              </Nav.Link>
            ))}
          </>
        )}
      </Nav>
    );
  }

  return (
    <Nav className="app-horizontal-nav align-items-center">
      <Nav.Link as={NavLink} to="/" end className="app-nav-link">
        {t.home}
      </Nav.Link>
      {roleLinks.length > 0 && (
        <NavDropdown title={roleTitle} id="role-nav-dropdown" className="app-nav-dropdown">
          {roleLinks.map(([to, label, icon]) => (
            <NavDropdown.Item as={NavLink} to={to} key={to}>
              <span className="nav-icon">{icon}</span> {label}
            </NavDropdown.Item>
          ))}
        </NavDropdown>
      )}
    </Nav>
  );
};

export default NavBar;
